import {addClass, event, removeClassAll, selectDoc, selectArr, removeClass} from "../utils/utils";

import {initSlider} from "../helpers/service.slider";
import {initFCollectionProductCard} from "./component.home";

const props = {
    story: selectDoc('#section-story-hero .bottom-content .icons'),
    storyIcons: selectArr('#section-story-hero .icon'),
    storyContent: selectArr('#section-story-hero .icons-content .content'),
    currentStory: 0,
    storyProgressBarPercentage: 0,
    storyStaticBar: selectDoc('#story-load-bar .static'),
    storyProgressBar: selectDoc('#story-load-bar .progress'),
    mainContainer: selectDoc('#section-story-main')
}

const initStoryPress = () => {
    let g = initSlider(`#press-reviews-slider`, {
        type: 'carousel',
        rewind: true,
        focusAt: 'center',
        animationDuration: 500,
        autoplay: 5000,
        hoverpause: true,
        peek: {
            before: 0,
            after: 0
        }
    }, true);
    // @ada
    $(".product-card .image").each(function(){
        const hoverImage = $(this).find('.content.active').next('.color-img-hover').length;
        $(this).focusin(function () {
            $(this).next('.quickview').css('opacity', '1');
            $(this).find('.content.active').next('.color-img-hover').addClass('with-focus');
            if(hoverImage > 0) {
                $(this).find('.content.active').css('opacity', '0');
            }
        });
        $(this).focusout(function () {
            $(this).find('.content.active').css('opacity', '1');
            $(this).find('.content.active').next('.color-img-hover').removeClass('with-focus');
            $(this).next('.quickview').css('opacity', '0');
        });
    });

    $(".product-card .quickview").each(function(){
        $(this).focusin(function () {
            $(this).css('opacity', '1');
        });
        $(this).focusout(function () {
            $(this).css('opacity', '0');
        });
    });


    g.on('run.after', evt => {
        removeClassAll(selectArr('#section-story-press .quotes .quote'), 'active');
        let slide = selectDoc('#press-reviews-slider .glide__slide.glide__slide--active');
        addClass(selectDoc(`#${slide.getAttribute('data-quote-id')}`), 'active');
    });
}
const initStoryProps = () => {
    if(props.storyIcons.length > 0) {
        const activeStory = (story) => {
            removeClassAll(props.storyIcons, 'active');
            removeClassAll(props.storyContent, 'active');
            addClass(story, 'active');
            addClass(selectDoc(`#${story.id.replace('icon', 'content')}`), 'active');
            props.currentStory = parseInt(story.id.replace('story-icon-', ''))
            props.storyProgressBarPercentage = (props.currentStory * increase * 16.7);
            if(props.currentStory === 0) {
                props.story.scrollLeft = 0;
            } else {
                let limit = 0;
                if (window.innerWidth <= 768) {
                    limit = props.storyIcons[0].getBoundingClientRect().width;
                }
                if(limit > 0) {
                    let scrollAmount = 0,
                        slideTimer = setInterval(function () {
                            props.story.scrollLeft += 30;
                            scrollAmount += 30;
                            if (scrollAmount >= limit) {
                                window.clearInterval(slideTimer);
                            }
                        }, 25);
                }
            }
        }

        const initIntervals = () => {
            props.showInterval = setInterval(function () {
                props.currentStory++;
                if(props.currentStory === props.storyIcons.length) {
                    props.currentStory = 0;
                }
                let next = selectDoc(`#story-icon-${props.currentStory}`);
                if(next) {
                    activeStory(next);
                }
            }, 5000);

            props.progressInterval = setInterval(function () {
                props.storyProgressBarPercentage += increase;
                if(props.storyProgressBarPercentage > 100) {
                    props.storyProgressBarPercentage = 0;
                }
                props.storyProgressBar.style.left = `-${100 - props.storyProgressBarPercentage}%`;
            }, 300);
        }

        const barSize = () => {
            /*let size = 0;
            props.storyIcons.map(icon => {
                size += icon.getBoundingClientRect().width;
            })
            props.storyStaticBar.style.width = `${size}px`;
            props.storyProgressBar.style.width = `${size}px`;*/
        }

        let increase = (100/(props.storyIcons.length * 16.7));

        props.storyIcons.map(s => {
            event(s, 'click', function () {
                activeStory(s);
            })
        })

        event(props.story,'mouseenter', function () {
            if(props.showInterval && props.progressInterval) {
                clearInterval(props.showInterval)
                clearInterval(props.progressInterval)
                props.showInterval = null;
                props.progressInterval = null;
                props.storyProgressBarPercentage = (props.currentStory * increase * 16.7);
            }
        });

        event(props.story,'mouseleave', function () {
            if(!props.showInterval && !props.progressInterval) {
                initIntervals()
            }
        });

        event(window, 'resize', barSize);

        if(!props.showInterval && !props.progressInterval) {
            initIntervals()
            barSize()
        }
    }
}

const initializer = () => {
    selectArr('.products-slider').map(slider => {
        initSlider(`#${slider.id}`, {
            perView: 3,
            type: 'carousel',
            rewind: true,
            bound: true,
            hoverpause: false,
            animationDuration: 1000,
            peek: {
                before: 0,
                after: 0
            },
            breakpoints: {
                1024: {
                    perView:3
                },
                767: {
                    animationDuration: 500,
                    perView: 1,
                    gap: 10,
                    peek: {
                        before: 0,
                        after: 70
                    }
                }
            }
        }, true);
    });
    initFCollectionProductCard();
    initStoryProps();
    initStoryPress();
}

export const Story = {
    init: () => initializer()
}
